import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Editor from '@monaco-editor/react';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import {
  UpdateSystemConfigBIZ
} from '../../../redux/actions/business/systemConfigActions';

import style from "../../../global.scss";
import LoadingButton from '../../../components/buttons/Button';

// mode 2 - edit the config blob in the JSON editor
// mode 3 - edit only the description
const MODE_JSON = 2;
const MODE_DESCRIPTION = 3;

const SystemConfigModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [mode, setMode] = useState(-1);
  const [formData, setFormData] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const editorRef = useRef(null);

  const handleClose = () => {
    setOpen(false);
    setMode(-1);
    setFormData("");
    setDescription("");
  };

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
    // Auto-format when editor first loads
    editor.getAction('editor.action.formatDocument').run();
  };

  useEffect(() => {
    try {
      if(open){
        if(update.defaultMode === MODE_JSON){
          setMode(MODE_JSON);
          setFormData(update.json);
        }else if(update.defaultMode === MODE_DESCRIPTION){
          setMode(MODE_DESCRIPTION);
          setDescription(update.description || "");
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    try {
      if (mode === MODE_JSON){
        // The model rejects invalid JSON server-side with a 400 — catching it
        // here gives a useful message instead of a generic failure toast.
        try {
          JSON.parse(formData);
        } catch (err) {
          toast.error("Config is not valid JSON");
          return;
        }

        dispatch(UpdateSystemConfigBIZ(update?.id, { json: formData }, setLoading)).then(() => {
          handleGet(setLoading).then(() => {
            handleClose();
          })
        });
      } else if (mode === MODE_DESCRIPTION){
        dispatch(UpdateSystemConfigBIZ(update?.id, { description: description }, setLoading)).then(() => {
          handleGet(setLoading).then(() => {
            handleClose();
          })
        });
      } else {
        toast.error("Invalid modal");
        handleClose();
      };
    } catch (err) {}
  };


  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={mode === MODE_DESCRIPTION ? "sm" : "md"} className="modal">
          <Box width={"100%"}
            sx={{ margin: mode === MODE_DESCRIPTION ? "15px" : "15px 15px 30px 15px"}}>
            <Typography variant='h6' sx={{ color: style["primary"] }}>
              {title}
            </Typography>
          </Box>
          {
            open && mode === MODE_JSON
            &&
            <Editor height="80vh"
              language={"json"}
              value={formData || "//no content provided"}
              onChange={(e) => setFormData(e)}
              theme='vs-dark'
              options={{
                wordWrap: true,
                formatOnPaste: true,
                formatOnType: true,
                scrollBeyondLastLine: false,
              }}
              onMount={handleEditorDidMount}
              />
          }
          {
            open && mode === MODE_DESCRIPTION
            &&
            <Box sx={{ padding: "0px 15px 20px 15px" }}>
              <TextField
                label="Description"
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                inputProps={{ maxLength: 255 }}
                helperText={`${description.length}/255`}
                />
            </Box>
          }
          <Divider
            sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='outlined'
              onClick={handleClose}>
              Close
            </Button>
            <LoadingButton
              variant='outlined'
              loading={loading}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default SystemConfigModal;
